import { useEffect, useState } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { useService } from '../app/context';
import type { PreparedAttachment } from '../domain/capture/model';
import { Icon } from './Icons';
import { downloadBlob } from '../infrastructure/platform/files';

export function AttachmentImage({ id, prepared, onRemove }: { id: string; prepared?: PreparedAttachment; onRemove?: () => void }) {
  const { db } = useService();
  const value = useLiveQuery(async () => {
    if (prepared) return prepared;
    const metadata = await db.attachments.get(id);
    if (!metadata) return null;
    const data = await db.attachmentBlobs.get(metadata.sha256);
    return data ? { metadata, data } : { metadata, data: null };
  }, [db, id, prepared]);
  const [url, setUrl] = useState('');
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!value?.data) return;
    const next = URL.createObjectURL(value.data.blob); setUrl(next); setFailed(false);
    return () => URL.revokeObjectURL(next);
  }, [value]);
  return <figure className="attachment">
    {url && !failed ? <img src={url} alt={value?.metadata.name || '记录图片'} onError={() => setFailed(true)} /> : <div className="image-placeholder"><Icon name="image" size={28} /><span>{failed ? '此设备无法预览，原文件仍保留' : value === undefined ? '读取图片…' : '图片字节无法读取'}</span></div>}
    <figcaption><span title={value?.metadata.name}>{value?.metadata.name || '图片'}</span><span className="attachment-actions">
      {value?.data && <button className="icon-button" aria-label={`下载原图 ${value.metadata.name}`} onClick={() => downloadBlob(value.data!.blob, value.metadata.name)}><Icon name="download" size={17} /></button>}
      {onRemove && <button className="icon-button" aria-label={`移除图片 ${value?.metadata.name || ''}`} onClick={onRemove}><Icon name="close" size={17} /></button>}
    </span></figcaption>
  </figure>;
}
